import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    const quickLinks = [
        { name: 'Home', href: '/Home' },
        { name: 'About', href: '/About' },
        { name: 'Projects', href: '/Projects' },
        { name: 'Services', href: '/Services' },
        { name: 'Get In Touch', href: '/Contacts' }
    ];

    return (

        <div className='footer'>
            <div className='footerPc'>
                <div className='footerContents'>
                    <div className='footerContent1'>
                        <svg className='logoSvg' width="53" height="44" viewBox="0 0 53 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34.049 1.42755C33.6207 2.39119 29.3914 11.8669 24.6267 22.4669C19.8621 33.0669 15.8469 42.0609 15.6863 42.4356C15.4722 42.971 15.954 43.1316 17.6671 42.971L19.9156 42.8104L28.1601 24.3407C32.7106 14.169 36.8864 4.85381 37.4753 3.56896C38.4389 1.42755 38.4389 1.26694 37.5823 0.999265C37.1005 0.838659 36.2439 0.463915 35.7086 0.196238C34.9056 -0.232045 34.6379 -0.0179039 34.049 1.42755Z" fill="white" />
                            <path d="M50.4305 0.999252C49.5204 1.374 48.5032 1.85582 48.2355 2.17703C47.9679 2.44471 44.5951 9.77905 40.687 18.4518C36.8325 27.1245 33.085 35.369 32.389 36.7609C31.6395 38.2063 31.2648 39.3306 31.4254 39.3306C32.2284 39.3306 36.5648 35.3154 37.9032 33.2811C39.188 31.4609 53.0002 1.374 53.0002 0.517435C53.0002 0.142688 52.5184 0.249757 50.4305 0.999252Z" fill="white" />
                            <path d="M38.064 8.4407C36.4579 12.0276 32.3892 21.0215 29.07 28.4629C25.7508 35.9043 23.0205 42.0609 23.0205 42.2215C23.0205 42.3821 24.0377 42.168 25.3225 41.8468C28.0528 41.0437 27.1963 42.5963 37.4216 19.6296L45.3448 1.85585H43.1499H40.9549L38.064 8.4407Z" fill="white" />
                            <path d="M0 8.54777C0 8.65484 2.35556 14.0084 5.24648 20.4326C8.1374 26.8569 11.0819 33.4952 11.7778 35.1548C12.4738 36.868 13.1697 38.2599 13.3303 38.2599C13.491 38.2599 14.0798 37.2427 14.6152 35.9579L15.5253 33.6558L10.3324 21.9851L5.08588 10.3144L2.56971 9.3508C1.12425 8.81545 0 8.49424 0 8.54777Z" fill="white" />
                            <path d="M16.2747 8.92248L14.5615 9.45783L16.4353 13.5801C17.506 15.8285 18.7908 18.7194 19.3797 20.0578L20.4504 22.4669L21.4141 20.5932C22.003 19.576 22.4312 18.3982 22.4848 18.0235C22.4848 17.1134 18.6302 8.28005 18.2555 8.33359C18.0949 8.38712 17.1848 8.6548 16.2747 8.92248Z" fill="white" />
                            <path d="M9.79695 10.2609C8.83331 10.3679 8.03027 10.5285 8.03027 10.5821C8.03027 10.6892 10.0646 15.1861 12.4737 20.7003L16.9707 30.6578L18.0414 28.1952L19.0586 25.679L15.5788 17.7558C13.6515 13.4195 11.9384 9.93966 11.7778 9.99319C11.6172 9.99319 10.7071 10.1538 9.79695 10.2609Z" fill="white" />
                        </svg>
                    </div>

                    <div className='footerContent2'>
                        <div className='quickLinks'>
                            <div className='menu'>
                                <h2>MENU</h2>
                            </div>
                            <div className='menuContents'>
                                <ul>
                                    {quickLinks.map((link, index) => (
                                        <li key={index}>
                                            <a href={link.href}
                                                onClick={() => {
                                                    navigate(link.href);
                                                    window.scrollTo({ top: 0 })
                                                }}>{link.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className='contactDetails'>
                            <div className='contact'>
                                <h2>CONTACT</h2>
                            </div>
                            <div className='contactContents'>
                                <a href="mailto:v2constructionss24@gmail.com">
                                    <p>v2constructionss24@gmail.com</p>
                                </a>
                                < div className='contactContents-phoneNumbers'>
                                    <a href='tel:+918939472985'>
                                        <p>+91 8939472985</p>
                                    </a>
                                    <a href='tel:+918939472985'>
                                        <p>+91 8939472985</p>
                                    </a>
                                </div>
                                <p>
                                    No 112a, Station Rd,<br />
                                    Radha Nagar, Chromepet,<br />
                                    Chennai, Tamil Nadu 600044.
                                </p>
                            </div>
                        </div>
                        <div className='socialMediaLinks'>
                            <div className='social'>
                                <h2>SOCIAL</h2>
                            </div>

                            <div className='socialMediaSvgs'>

                            <a href="https://www.facebook.com/profile.php?id=61574629150366" target="_blank" rel="noopener noreferrer">
                                <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.989136" width="32" height="32" rx="16" fill="url(#paint0_linear_676_56)" />
                                    <path d="M15.2749 13.7143H12.9891V16H15.2749V22.8571H18.7034V16H20.7834L20.9891 13.7143H18.7034V12.7623C18.7034 12.216 18.8131 12 19.3411 12H20.9891V9.14282H18.2417C16.1868 9.14282 15.2749 10.048 15.2749 11.7805V13.7143Z" fill="white" />
                                    <defs>
                                        <linearGradient id="paint0_linear_676_56" x1="16.9891" y1="0" x2="16.9891" y2="32" gradientUnits="userSpaceOnUse">
                                            <stop />
                                            <stop offset="1" stopColor="#585858" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                </a>
                                <a href="https://www.instagram.com/v2constructionss_?igsh=amY3MWY4aW9jNDk1" target="_blank" rel="noopener noreferrer">
                                <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.989136" width="32" height="32" rx="16" fill="url(#paint0_linear_676_64)" />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M16.9891 8C14.8158 8 14.5451 8.00933 13.6905 8.04933C10.7838 8.18267 9.17047 9.79467 9.03714 12.7013C8.99847 13.556 8.98914 13.828 8.98914 16C8.98914 18.1733 8.99847 18.4453 9.03714 19.2987C9.17047 22.204 10.7838 23.8187 13.6905 23.952C14.5451 23.9907 14.8158 24 16.9891 24C19.1625 24 19.4345 23.9907 20.2891 23.952C23.1905 23.8187 24.8105 22.2067 24.9411 19.2987C24.9798 18.4453 24.9891 18.1733 24.9891 16C24.9891 13.828 24.9798 13.556 24.9411 12.7013C24.8105 9.79867 23.1958 8.18133 20.2891 8.04933C19.4345 8.00933 19.1625 8 16.9891 8ZM16.9891 9.44267C19.1251 9.44267 19.3785 9.45067 20.2225 9.48933C22.3918 9.588 23.4025 10.616 23.5025 12.768C23.5398 13.612 23.5478 13.864 23.5478 16C23.5478 18.136 23.5398 18.3893 23.5025 19.232C23.4025 21.3827 22.3931 22.4133 20.2225 22.512C19.3785 22.5493 19.1265 22.5587 16.9891 22.5587C14.8531 22.5587 14.5998 22.5507 13.7571 22.512C11.5838 22.412 10.5771 21.38 10.4771 19.232C10.4398 18.3893 10.4305 18.136 10.4305 16C10.4305 13.864 10.4398 13.6107 10.4771 12.768C10.5758 10.6147 11.5865 9.58667 13.7571 9.488C14.5998 9.44933 14.8531 9.44267 16.9891 9.44267ZM12.8811 16C12.8811 13.7307 14.7211 11.892 16.9891 11.892C19.2571 11.892 21.0971 13.732 21.0971 16C21.0971 18.2693 19.2571 20.108 16.9891 20.108C14.7211 20.108 12.8811 18.2693 12.8811 16ZM16.9891 18.6667C15.5158 18.6667 14.3225 17.4733 14.3225 16C14.3225 14.528 15.5158 13.3333 16.9891 13.3333C18.4611 13.3333 19.6571 14.5267 19.6571 16C19.6571 17.4733 18.4611 18.6667 16.9891 18.6667ZM20.2985 11.7307C20.2985 11.2 20.7291 10.7707 21.2585 10.7707C21.7905 10.7707 22.2198 11.2 22.2198 11.7307C22.2198 12.2613 21.7891 12.6907 21.2585 12.6907C20.7278 12.6907 20.2985 12.26 20.2985 11.7307Z"
                                        fill="white"
                                    />
                                    <defs>
                                        <linearGradient id="paint0_linear_676_64" x1="16.9891" y1="0" x2="16.9891" y2="32" gradientUnits="userSpaceOnUse">
                                            <stop />
                                            <stop offset="1" stopColor="#585858" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                </a>
                                
                            </div>

                        </div>
                    </div>
                </div>

                <div className='copyRight'>
                    <h2>&copy; 2025 All Rights Reserved.</h2>
                </div>
            </div>
            <div className='footerMobile'>
                <div className='getInTouchMob'>
                    <h2>GET IN TOUCH</h2>
                </div>
                <div className='addressEmailContentsMob'>
                    <div className='addressContentsMob'>
                        <div className='addressMob'>
                            <div>
                                <h2>ADDRESS</h2>
                            </div>
                            <div>
                                <p>
                                    No 112a, Station Rd,<br />
                                    Radha Nagar, Chromepet,<br />
                                    Chennai, Tamil Nadu 600044.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='emailContentsMob'>
                        <div className='emailMob'>
                            <div>
                                <h2>EMAIL</h2>
                            </div>
                            <a href="mailto:v2constructionss24@gmail.com">
                                <p>v2constructionss24@gmail.com</p>
                            </a>
                        </div>
                        <div className='callusMob'>
                            <div>
                                <h2>CALL US</h2>
                            </div>
                            <div className='callusMob-phoneNumbers' >
                                <a href="tel:+918939472985">
                                    <p>+91 8939472985</p>
                                </a>
                                <a href="tel:+919444149314">
                                    <p>+91 9444149314</p>
                                </a>
                            </div>
                        </div>
                        <div className='socialMediaLinksMob'>
                            <div className='socialMob'>
                                <h2>SOCIAL</h2>
                            </div>
                            <div className='socialMediaSvgMobile'>
                            <a href="https://www.facebook.com/profile.php?id=61574629150366" target="_blank" rel="noopener noreferrer">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" rx="20" fill="url(#paint0_linear_781_101)" />
                                    <path d="M17.6429 17.1667H14.5V20H17.6429V28.5H22.3571V20H25.2171L25.5 17.1667H22.3571V15.9866C22.3571 15.3094 22.508 15.0417 23.234 15.0417H25.5V11.5H21.7223C18.8969 11.5 17.6429 12.622 17.6429 14.7697V17.1667Z" fill="white" />
                                    <defs>
                                        <linearGradient id="paint0_linear_781_101" x1="20" y1="0" x2="20" y2="40" gradientUnits="userSpaceOnUse">
                                            <stop />
                                            <stop offset="1" stopColor="#585858" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                </a>

                                <a href="https://www.instagram.com/v2constructionss_?igsh=amY3MWY4aW9jNDk1" target="_blank" rel="noopener noreferrer">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" rx="20" fill="url(#paint0_linear_781_103)" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M20 10C17.0117 10 16.6395 10.0117 15.4643 10.0617C11.4677 10.2283 9.24933 12.2433 9.066 15.8767C9.01283 16.945 9 17.285 9 20C9 22.7167 9.01283 23.0567 9.066 24.1233C9.24933 27.755 11.4677 29.7733 15.4643 29.94C16.6395 29.9883 17.0117 30 20 30C22.9883 30 23.3623 29.9883 24.5375 29.94C28.5268 29.7733 30.7543 27.7583 30.934 24.1233C30.9872 23.0567 31 22.7167 31 20C31 17.285 30.9872 16.945 30.934 15.8767C30.7543 12.2483 28.5342 10.2267 24.5375 10.0617C23.3623 10.0117 22.9883 10 20 10ZM19.9986 11.8034C22.9356 11.8034 23.284 11.8134 24.4445 11.8618C27.4273 11.9851 28.817 13.2701 28.9545 15.9601C29.0058 17.0151 29.0168 17.3301 29.0168 20.0001C29.0168 22.6701 29.0058 22.9868 28.9545 24.0401C28.817 26.7284 27.4291 28.0168 24.4445 28.1401C23.284 28.1868 22.9375 28.1984 19.9986 28.1984C17.0616 28.1984 16.7133 28.1884 15.5546 28.1401C12.5663 28.0151 11.1821 26.7251 11.0446 24.0401C10.9933 22.9868 10.9805 22.6701 10.9805 20.0001C10.9805 17.3301 10.9933 17.0134 11.0446 15.9601C11.1803 13.2684 12.57 11.9834 15.5546 11.8601C16.7133 11.8118 17.0616 11.8034 19.9986 11.8034ZM14.3506 20.0001C14.3506 17.1634 16.8806 14.8651 19.9991 14.8651C23.1176 14.8651 25.6476 17.1651 25.6476 20.0001C25.6476 22.8367 23.1176 25.1351 19.9991 25.1351C16.8806 25.1351 14.3506 22.8367 14.3506 20.0001ZM19.9977 23.3335C17.9719 23.3335 16.3311 21.8418 16.3311 20.0002C16.3311 18.1602 17.9719 16.6668 19.9977 16.6668C22.0217 16.6668 23.6662 18.1585 23.6662 20.0002C23.6662 21.8418 22.0217 23.3335 19.9977 23.3335ZM24.5518 14.6635C24.5518 14.0001 25.1439 13.4635 25.8718 13.4635C26.6033 13.4635 27.1936 14.0001 27.1936 14.6635C27.1936 15.3268 26.6014 15.8635 25.8718 15.8635C25.1421 15.8635 24.5518 15.3251 24.5518 14.6635Z" fill="white" />
                                    <defs>
                                        <linearGradient id="paint0_linear_781_103" x1="20" y1="0" x2="20" y2="40" gradientUnits="userSpaceOnUse">
                                            <stop />
                                            <stop offset="1" stopColor="#585858" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>

                <div className='copyRightMob'>
                    <h2>&copy; 2025 All Rights Reserved.</h2>
                </div>
            </div>
        </div>

    );
}

export default Footer